_ = require 'underscore'
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list')

module.exports = class extends React.Component
  displayName: 'BoardlistSectionHeaderLinkComponent'

  render: t.renderable ->
    { url, iconClass, titleKey, titleText, onClick, linkClasses } = @props

    defaultClasses =
      'boards-page-board-section-header-options-item': true

    classes = _.extend(defaultClasses, linkClasses)

    # We deliberately don't use the icon/locale-key overload of t.icon
    # because it inserts a space between the icon and its text, which
    # looks weird since the text will be underlined.

    t.link url,
      class: t.classify(classes)
      onClick: onClick
    , =>
      t.icon iconClass, { class: 'boards-page-board-section-header-options-item-icon' }
      t.span '.boards-page-board-section-header-options-item-name', =>
        t.format titleKey
        if titleText
          t.text ": #{titleText}"



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-section-header-link-component.coffee